var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { ArrowStrokeLeft, Close } from "@epic-ui/icons";
import { DialogTitle, DialogTitleBody } from "./DialogLayoutBase";
import { makeStyles, styled } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import { sideDialogBaseStyles } from "../../styles";
var ReturnButton = styled(IconButton)(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        position: "absolute",
        left: spacing(3),
        top: spacing(7),
    });
}, { name: "EuiReturnButton" });
var useStyles = makeStyles(sideDialogBaseStyles, {
    name: "EuiDialogLayoutSide",
});
export var DialogLayoutSide = function (_a) {
    var dialogTitle = _a.dialogTitle, _b = _a.DialogTitleProps, _c = _b === void 0 ? { disableTypography: false } : _b, disableTypography = _c.disableTypography, // Intercept prop to replace typography
    DialogTitleProps = __rest(_c, ["disableTypography"]), onClickReturn = _a.onClickReturn, ReturnButtonProps = _a.ReturnButtonProps, onClose = _a.onClose, displayClose = _a.displayClose, onClickClose = _a.onClickClose, CloseButtonProps = _a.CloseButtonProps, children = _a.children, DialogContentProps = _a.DialogContentProps, dialogActions = _a.dialogActions, DialogActionsProps = _a.DialogActionsProps, TitleTypographyProps = _a.TitleTypographyProps;
    var classes = useStyles();
    var hasDialogTitle = Boolean(dialogTitle || displayClose || onClickReturn);
    return (React.createElement(React.Fragment, null,
        hasDialogTitle && (React.createElement(DialogTitle, __assign({}, DialogTitleProps, { className: clsx(classes.title, DialogTitleProps.className) }),
            onClickReturn && (React.createElement(ReturnButton, __assign({ size: "small", onClick: onClickReturn }, ReturnButtonProps),
                React.createElement(ArrowStrokeLeft, null))),
            React.createElement(DialogTitleBody, null, disableTypography ? (dialogTitle) : (React.createElement(Typography, __assign({ variant: "h5", component: "h2", color: "textPrimary" }, TitleTypographyProps), dialogTitle))),
            displayClose && (React.createElement(IconButton, __assign({ size: "small", onClick: onClickClose || (function (e) { return onClose && onClose(e, "backdropClick"); }) }, CloseButtonProps),
                React.createElement(Close, null))))),
        children && (React.createElement(DialogContent, __assign({}, DialogContentProps, { className: clsx(classes.content, DialogContentProps === null || DialogContentProps === void 0 ? void 0 : DialogContentProps.className) }), children)),
        dialogActions && (React.createElement(DialogActions, __assign({}, DialogActionsProps, { className: clsx(classes.actions, DialogActionsProps === null || DialogActionsProps === void 0 ? void 0 : DialogActionsProps.className) }), dialogActions))));
};
//# sourceMappingURL=DialogLayoutSide.js.map